import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { zones } from "@/mocks/home";

export default function ZoneSection() {
  return (
    <section id="zones" className="relative w-full overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute inset-0 hl-grid-lines opacity-60" />

      <div className="relative mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="BLACK-TALK ZONES"
            title="黑料专区 · 按领域直达"
            desc="每一个专区只放同一类内容，想找某个方向的爆料，从专区进去比翻列表更快。"
            actionText="全部专区入口"
            actionHref="#zones"
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {zones.map((zone, index) => (
            <Reveal key={zone.name} delay={index * 60}>
              <a
                href="#zones"
                className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 cursor-pointer"
              >
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    src={zone.cover}
                    alt={`${zone.name}封面`}
                    title={`31黑料网黑料专区 ${zone.name}`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 ease-soft group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
                  <span className="absolute right-4 top-4 rounded-full bg-black/45 px-2.5 py-1 text-[11px] font-label text-white/90 backdrop-blur">
                    {zone.count}
                  </span>
                  <div className="absolute bottom-4 left-4 flex items-center gap-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/15 backdrop-blur">
                      <i className={`${zone.icon} text-lg text-white`} />
                    </span>
                    <span className="font-heading text-base font-bold text-white md:text-lg">
                      {zone.name}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between gap-3 px-5 py-4">
                  <p className="text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {zone.desc}
                  </p>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-background-200 text-foreground-500 transition-colors duration-300 group-hover:border-primary-300 group-hover:text-primary-700">
                    <i className="ri-arrow-right-line text-base" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}